import React from "react";
import { DateFormat } from "common/helpers/Format";
import { Nullable } from "common/types";

export interface IDateTimeFormatterProps {
  dateString: Nullable<string | any>;
  includeTime?: boolean;
}

export const DateTimeFormatter: React.FC<IDateTimeFormatterProps> = ({ dateString, includeTime = false }) => {
  return <>{includeTime ? DateFormat(dateString) : DateFormat(dateString, "shortDate")}</>;
};
